import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { accountApi, useCustomerAuth } from "@/context/CustomerAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AccountCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sid) return navigate("/account/login", { replace: true });
    accountApi.post("/account/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data.user);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true });
      })
      .catch(() => navigate("/account/login?error=google", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-3 text-forest">
      <Loader2 className="animate-spin" size={26} />
      <p className="text-sm text-mutedgreen">Signing you in…</p>
    </div>
  );
}
